import { render, staticRenderFns } from "./MyCustomers.vue?vue&type=template&id=585b0093"
import script from "./MyCustomers.vue?vue&type=script&lang=js"
export * from "./MyCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports